import type { PokerHomeGames } from '@ps/web-martech-cms-types';
import type {
  ClubSeasonStatsResponse,
  GetClubSeasonStatsRequest
} from '@ps/web-shared-api-types/v1-preview/SwHomeGames';

import type { ExtractDispatchFromModel, WidgetEffectParams } from '@swf/core/store';

import { PKR_LOADERS } from '../../constants';
import { ENDPOINTS } from '../../constants/endpoints';
import type { HomeGamesWidgetModel } from '../../model';

interface Props {
  clubId: string;
  seasonId: string;
  isPlayMoney?: boolean;
}

export const fetchClubSeasonStats = async (
  { clubId, seasonId, isPlayMoney = false }: Props,
  { request, dispatch, widget: { uid } }: WidgetEffectParams<PokerHomeGames>
) => {
  const widgetDispatch: ExtractDispatchFromModel<HomeGamesWidgetModel> = dispatch[uid];
  const loaderName = PKR_LOADERS.clubSeasonStats;
  widgetDispatch.setLoading({ isLoading: true, loaderName });

  try {
    const { body } = await request<ClubSeasonStatsResponse>({
      service: ENDPOINTS.clubSeasonStats,
      body: {
        getClubSeasonStats: {
          clubId: Number(clubId),
          seasonId: Number(seasonId),
          playMoney: isPlayMoney
        }
      } as GetClubSeasonStatsRequest,
      http: true
    });

    if (body?.seasonStatsReply?.stats) {
      widgetDispatch.setClubSeasonStats({ clubId, stats: body.seasonStatsReply.stats });
    }
  } catch (error) {
    widgetDispatch.setLoading({ isLoading: false, loaderName });
  } finally {
    widgetDispatch.setLoading({ isLoading: false, loaderName });
  }
};
